var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var DotLoader = function (_a) {
    var _b;
    var inline = _a.inline, rest = __rest(_a, ["inline"]);
    return (React.createElement("div", __assign({ className: cn("DotLoader", (_b = {}, _b[styles.inline] = inline, _b)) }, rest),
        React.createElement("span", { className: styles.dot }),
        React.createElement("span", { className: cn(styles.dot, styles.second) }),
        React.createElement("span", { className: cn(styles.dot, styles.third) })));
};
export default DotLoader;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/dotLoader/index.tsx
// module id = VdRz
// module chunks = 2